import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Tabs from "@mui/material/Tabs";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import * as React from "react";
import styled, { css } from "styled-components";
import { multilineEllipsis } from "./base.styles";
import { HXSectionSubtitleLabel, HXSectionTextContainer, HXSectionTimestamp, HXSectionTimestampLabel, HXSectionTitle, HXSectionTitleContainer, HXSectionTitleLabelContainer, HXSectionTitleText, HXSectionTitleWithRightElementContainer, HXPageTitleText, } from "./HXDesktopPage.styles";
export const pageHorizontalMargin = 80;
export const HXPage = styled.div `
    margin: 0 ${pageHorizontalMargin}px;
    margin-bottom: 16px;
    padding-top: 16px;
`;
const HXPageHeaderEl = styled.div `
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 0 8px;
`;
const HXPageHeaderRow = styled.div `
    display: flex;
    ${(props) => props.vertical
    ? css `
                  flex-direction: column;
                  gap: 16px;
              `
    : css `
                  flex-direction: row;
                  align-items: ${props.centerAlign ? "center" : "start"};
                  justify-content: space-between;
                  gap: 80px;
                  width: 100%;
              `}
`;
const HXPageBackLink = styled(Button).attrs({ variant: "text", startIcon: React.createElement(ChevronLeftIcon) }) ``;
export const HXPageHeader = (props) => {
    var _a;
    const onBack = props.onBack;
    return (_jsxs(HXPageHeaderEl, { className: props.className, children: [onBack && (_jsxs(HXPageHeaderRow, { vertical: false, children: [_jsx(HXPageBackLink, { onClick: (e) => onBack(e), children: (_a = props.customBackText) !== null && _a !== void 0 ? _a : "Back" }), props.rightOfBackContent] })), _jsx(HXPageHeaderRow, { vertical: !!props.separateActionsLine, children: props.children })] }));
};
export const HXPageTitle = (props) => {
    return (_jsxs(HXPageTitleEl, { maxLines: props.maxLines, children: [_jsx(HXPageTitleText, { children: props.children }), props.chipText && _jsx(Chip, { label: props.chipText, color: "default", size: "medium", variant: "outlined" })] }));
};
const HXPageTitleEl = styled.div `
    flex-shrink: 1;
    display: flex;
    align-items: center;
    gap: 16px;

    & > div:first-child {
        ${(props) => { var _a; return multilineEllipsis((_a = props.maxLines) !== null && _a !== void 0 ? _a : 2); }}
    }
`;
export const HXPageActions = styled.div `
    display: flex;
    gap: 16px;
    flex-shrink: 0;
`;
export const HXPageSubtabs = styled(Tabs) `
    align-self: stretch;
    margin-bottom: 16px;
    position: relative;

    & .MuiTabs-indicator {
        z-index: 1;
    }

    & .MuiTab-root {
        font-weight: ${fontWeights.SEMI_BOLD};
    }

    &::after {
        content: "";
        border-bottom: 1px solid ${colors.black_12};
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }
`;
const HXSubpageHeaderEl = styled.div `
    display: flex;
    gap: 16px;
`;
export const HXSubpageHeader = (props) => {
    return (_jsx(HXSubpageHeaderEl, { children: _jsx(HXPageHeaderRow, { vertical: !!props.separateActionsLine, centerAlign: props.centerAlign, children: props.children }) }));
};
export const HXSubpageActions = styled.div `
    display: flex;
    gap: 16px;
    flex-shrink: 0;
    margin-left: auto;
`;
import { MoreInfo } from "./MoreInfo";
export const HXSectionTitleWithTimestamp = (props) => {
    const showText = props.showText === undefined || props.showText;
    return (_jsxs(HXSectionTitleWithRightElementContainer, { children: [_jsxs(HXSectionTitleContainer, { children: [props.title && _jsx(HXSectionTitle, { children: props.title }), props.subtitle && _jsx(HXSectionSubtitleLabel, { hasError: props.hasError === true, children: props.subtitle }), props.text && (_jsx(_Fragment, { children: _jsxs(HXSectionTextContainer, { children: [showText && _jsx(HXSectionTitleText, { children: props.text }), showText && props.textTooltip && _jsx(MoreInfo, { children: props.textTooltip })] }) }))] }), _jsxs(HXSectionTitleLabelContainer, { children: [props.timestampLabel && _jsx(HXSectionTimestampLabel, { children: props.timestampLabel }), props.timestamp && _jsx(HXSectionTimestamp, { children: props.timestamp })] })] }));
};
export const HXSectionTitleWithRightElement = (props) => {
    return (_jsxs(HXSectionTitleWithRightElementContainer, { children: [_jsx(HXSectionTitle, { children: props.title }), props.children] }));
};
